
import { defineComponent } from 'vue';

export default defineComponent({
	props: {
		visible: { type: Boolean, required: true}
	},
	setup(props, { emit }) {
		const handleConfirm = () => {
			emit('confirm');
			handleClose();
		};

		const handleClose = () => {
			emit('dialog-close');
		};

		return {
			handleClose,
			handleConfirm
		};
	}
});
